export default __webpack_public_path__ + "static/media/template_pro__0014_13---NickPat.94c34c26.png";